// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { Util } from '@microsoft/applicationinsights-common';
var Operation = /** @class */ (function () {
    function Operation() {
        this.id = Util.newId();
        if (window && window.location && window.location.pathname) {
            this.name = window.location.pathname;
        }
    }
    return Operation;
}());
export { Operation };
//# sourceMappingURL=Operation.js.map